module.exports = __webpack_public_path__ + "public/StoreIcon/manageMenuIcon.svg?87c7840a";